module.exports = __webpack_public_path__ + "static/outlook_web_3-27c083569f09df80bb717d164202f825.png";